import { createConsumer } from "@anycable/web";

type HandoffMessage = {
  handoff?: boolean;
  intercom_user?: {
    user_id: number;
    email: string;
    name: string;
    intercom_user_jwt: string;
  };
};

type AnyCableConsumer = ReturnType<typeof createConsumer>;
type AnyCableSubscription = ReturnType<AnyCableConsumer["subscriptions"]["create"]>;

const state = {
  consumer: null as AnyCableConsumer | null,
  subscription: null as AnyCableSubscription | null,
  handoffHandled: false,
};

const getOrCreateConsumer = (): AnyCableConsumer => {
  if (!state.consumer) {
    state.consumer = createConsumer();
  }

  return state.consumer;
};

const handleMessage = (data: HandoffMessage) => {
  if (data.intercom_user && typeof window.updateIntercomUser === "function") {
    window.updateIntercomUser(data.intercom_user);
  }

  if (
    data.handoff === true &&
    !state.handoffHandled &&
    typeof window.performAdaToIntercomHandoff === "function"
  ) {
    state.handoffHandled = true;
    window.performAdaToIntercomHandoff();
  }
};

const startAdaHandoffCable = () => {
  if (state.subscription) {
    return;
  }

  const consumer = getOrCreateConsumer();

  state.subscription = consumer.subscriptions.create(
    { channel: "Ada::HandoffChannel" },
    {
      received: handleMessage,
    }
  );
};

// Unsubscribing ensures the next subscribe triggers a fresh `subscribed` callback
// on the server, which sends a new Intercom JWT.
const stopAdaHandoffCable = () => {
  if (state.subscription) {
    try {
      state.subscription.unsubscribe();
    } catch {
      // Unsubscribe may fail if already disconnected
    }
    state.subscription = null;
  }

  state.handoffHandled = false;
};

window.startAdaHandoffCable = startAdaHandoffCable;
window.stopAdaHandoffCable = stopAdaHandoffCable;
